import * as TYPES from './types'; 

const fetch = (module, payload, microservice = 'service') => ({
  ...payload,
  type: 'UNIVERSAL_FETCH_MODULE',
  microservice,
  module,
});

const fetchSuccess = (module, payload) => ({
  type: 'FETCH_MODULE_SUCCESS',
  module,
  payload,
});

const requestError = payload => ({
  type: 'FETCH_MODULE_ERROR',
  payload,
});

const remove = (module, payload, microservice = 'service') => ({
  ...payload,
  type: 'UNIVERSAL_REMOVE_MODULE',
  module,
  method: 'delete',
  microservice,
});

const update = (module, payload, microservice = 'service') => ({
  type: 'UNIVERSAL_UPDATE_MODULE',
  module,
  method: 'patch',
  microservice,
  data: payload.data,
});

const updateSuccess = payload => ({
  type: 'UPDATE_MODULE_SUCCESS',
  module: payload.module,
  data: payload.data,
});

const insert = (module, payload, microservice = 'service') => ({
  type: 'UNIVERSAL_INSERT_MODULE',
  method: 'put',
  module,
  microservice,
  data: payload.data,
});

const upload = (data, cb) => ({
  type: TYPES.UNIVERSAL_UPLOAD_FILE,
  data,
  cb,
});

const uploadLargeFile = (data, callback) => ({
  type: TYPES.UNIVERSAL_UPLOAD_LARGE_FILE,
  data,
  callback,
});

const deleteFile = (filename, cb) => ({
  type: TYPES.UNIVERSAL_DELETE_FILE,
  filename,
  cb,
});

export default {
  fetch,
  fetchSuccess,
  requestError,
  remove,
  update,
  insert,
  updateSuccess,
  upload,
  deleteFile,
  uploadLargeFile
};
